import {ClearanceItemAssetManagerComponent} from '../asset-management/clearance-item-asset-manager.component';
import { Component, Input, EventEmitter, Output, ViewChild, OnInit } from '@angular/core';
import { ClearanceItem, CIAsset } from '../clearance-item.model';
import { FormGroup, FormArray, FormBuilder } from '@angular/forms';
import { MaterializeAction } from 'angular2-materialize';
import { NotificationsService, Notification } from '../../shared/helper-components/index'
import { ClearanceItemTagComponent } from '../clearance-item-tag.component';
import { ClearanceItemGroupNameComponent } from './clearance-item-groupname.component';


type callBackWhenDone = (data: any) => void;

@Component({
    selector: 'bulk-actions',
    template: require('./clearance-item-bulk.component.html')
})
export class ClearanceItemBulkComponent implements OnInit {

    @ViewChild('groupName') groupNameComponent: ClearanceItemGroupNameComponent;
    @ViewChild('imageAsset') imageComponent: ClearanceItemAssetManagerComponent;
    @ViewChild('tagComponent') tagComponent: ClearanceItemTagComponent;
    @ViewChild('documentAsset') documentComponent: ClearanceItemAssetManagerComponent;

    @Input()
    itemList: ClearanceItem[] = [];
    @Input()
    projectId: string;
    @Input("modalId")
    currentModal: string;
    @Input()
    dataList: object[];   //this is to handle all kind of data in an array fashion, e.g. images
    @Output()
    bulkActionUpdated: EventEmitter<callBackWhenDone> = new EventEmitter<callBackWhenDone>();
    @Input('isClearanceUser')
    public isClearanceUser: boolean;

    masssUpdateForm: FormGroup;
    // modalActionsGN = new EventEmitter<string | MaterializeAction>();
    // currentModal: string;
    bulkForm: FormGroup;
    modalActions = new EventEmitter<string | MaterializeAction>();
    commentIsRequired: boolean;

    callBackWhenDone: callBackWhenDone;

    constructor(private _fb: FormBuilder,
        private _notificationsService: NotificationsService

    ) {

    }

    ngOnInit(): void {
        this.bulkForm = this._fb.group({});
    }

    setForm(form: FormGroup) {
        this.bulkForm = form;
    }

    initializeModal(modalName: string, callback: callBackWhenDone): void {
        if (this.itemList && this.itemList.filter(it => it.isSelected).length > 0) {
            this.currentModal = modalName;
            this.callBackWhenDone = callback;
            //this should be abstracted into an interface or something
            this.groupNameComponent.initForm();
            this.tagComponent.initItemForm(true);
            this.imageComponent.initItemForm([], true);
            this.documentComponent.initItemForm([], true);
            //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
            $('#' + modalName).modal('open');
        }
    }

    onGroupNameUpdate(groupName: FormGroup) {
        this.callBack(groupName);
    }


    addImages(): void {
        let selectedImages = this.imageComponent.getSelectedAssets();
        this.callBack(selectedImages);
    }

    addTags(): void {
        let selectedTags = this.tagComponent.getSelectedTags();
        this.callBack(selectedTags);
    }

    newTagAdded(tag: FormGroup): void {
        if (tag) {
            tag.controls.isSelected.setValue(!tag.controls.isSelected.value);
        }
    }

    addDocuments(): void {
        let selectedDocs = this.documentComponent.getSelectedAssets();
        this.callBack(selectedDocs);
    }

    changeStatus() {

        if (!this.bulkForm.valid) {
            this._notificationsService.add(new Notification('warn', 'Please enter comments (min 3 characters) to update the status, or click cancel to undo your changes.', 'Comments needed'));
            return;
        }
        this.callBack(this.bulkForm);
    }

    callBack(data: any){
        if (this.callBackWhenDone){
            this.callBackWhenDone(data) ;
            $('#' + this.currentModal).modal('close');
        }     
    }

    get tagsCanBeEdited(): boolean {
        let selectedItems = this.itemList.filter(it => it.isSelected);

        //check if the current user is a 'Clearance' one OR ALL of the items are NEW regardless of the user 
        return selectedItems.length > 0 && (this.isClearanceUser || selectedItems.filter(it => it.status.toUpperCase() === 'NEW').length == selectedItems.length);
    }

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/clearance-item/bulk-action/clearance-item-bulk.component.ts